import React from 'react';
import type { Theme } from '@material-ui/core';
import { Paper } from '@material-ui/core';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';
import { Typography } from '@klp/design/Typography';
import { ActionButton } from '@klp/design';
import { TransferProgressBar } from './TransferProgressBar';

type MappingTransferProps = {
    reportName: string | null;
    onTransfer: () => Promise<void>;
    onClose: () => void;
    isTransferring: boolean;
};

const styles = (theme: Theme) => ({
    paper: {
        padding: theme.spacing(2),
    },

    buttonsContainer: {
        marginTop: theme.spacing(2),
        display: 'flex',
        justifyContent: 'space-between',
        gap: theme.spacing(2),
    },
});

export const MappingTransfer: React.FC<MappingTransferProps> = ({
    reportName,
    onTransfer,
    onClose,
    isTransferring,
}) => {
    const classes = useKlpStyles({}, styles);

    const handleTransfer = async () => {
        await onTransfer();
    };

    return (
        <Paper className={classes.paper} elevation={2}>
            <Typography
                variant="subtitle1"
                translation="reportMapping.mappingTransfer.titleMappingFor"
            />
            <Typography
                variant="subtitle1"
                marginBottom="compact"
                klpPalette="secondary"
                klpColor="dark"
            >
                {reportName}
            </Typography>

            <Typography
                variant="body2"
                marginBottom="compact"
                translation="reportMapping.mappingTransfer.disclaimer"
            />
            <Typography
                variant="body2"
                marginBottom="compact"
                translation="reportMapping.mappingTransfer.disclaimerNightly"
            />

            <TransferProgressBar isTransferring={isTransferring} />
            <div className={classes.buttonsContainer}>
                <ActionButton
                    actionType="button"
                    variant="outlined"
                    color="secondary"
                    onClick={onClose}
                    disabled={isTransferring}
                    translation="general.cancel"
                    fullWidth={true}
                />
                <ActionButton
                    actionType="submit"
                    variant="contained"
                    color="secondary"
                    onClick={handleTransfer}
                    disabled={isTransferring}
                    isLoading={isTransferring}
                    translation="reportMapping.mappingTransfer.transfer"
                    fullWidth={true}
                />
            </div>
        </Paper>
    );
};
